import { NxNativeDateModule } from '@allianz/ng-aquila/datefield';
import { NxMessageToastService } from '@allianz/ng-aquila/message';
import { provideAllianzIcons } from '@allianz/ngx-brand-kit/icon';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  isDevMode,
  LOCALE_ID,
  provideAppInitializer,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideTransloco } from '@jsverse/transloco';
import { OAuthService, OAuthStorage, provideOAuthClient } from 'angular-oauth2-oidc';
import { routes } from './app.routes';
import { authConfig } from './configs/auth.config';
import { authInterceptor } from './interceptors/auth.interceptor';
import { errorInterceptor } from './interceptors/error.interceptor';
import config from './model/translaco.config';
import { AccessibilitySettingsService } from './services/accessibility-settings.service';
import { TranslocoHttpLoaderService } from './services/transloco-loader.service';

/** Runs once at bootstrap, before any route or HTTP request. */
export function initializeOAuthSession(): void {
  const oauthService = inject(OAuthService);
  oauthService.configure(authConfig);
  oauthService.setupAutomaticSilentRefresh();
}

/** Applies the stored text size / dark mode before the first render, so no page flashes in the wrong theme. */
export function initializeAccessibilitySettings(): void {
  inject(AccessibilitySettingsService).init();
}

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: TranslocoHttpLoaderService.defaultCultureLang },
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideAllianzIcons(),
    importProvidersFrom(NxNativeDateModule),
    provideHttpClient(withInterceptors([errorInterceptor, authInterceptor])),
    provideOAuthClient(),
    { provide: OAuthStorage, useValue: localStorage },
    provideAppInitializer(initializeOAuthSession),
    provideAppInitializer(initializeAccessibilitySettings),
    { provide: NxMessageToastService, useClass: NxMessageToastService },
    provideTransloco({
      config: {
        availableLangs: config.langs,
        defaultLang: TranslocoHttpLoaderService.defaultCultureLang,
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoaderService,
    }),
  ],
};
